module.exports = __webpack_public_path__ + "img/ymc_logo.9ebd734b.png";